import { GET_SHIPMENTS } from "../../type/shipment";
// **  Initial State
const initialState = {
  data: [],
  totalRecords: 0,
  totalPages: 1,
  percentage: 0,
  params: {},
};

const shipmentReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_SHIPMENTS:
      return {
        ...state,
        data: action.payload.results,
        totalPages: action.payload.totalPages,
        totalRecords: action.payload.totalResults,
        params: { limit: action.payload.limit, page: action.payload.page },
      };
    default:
      return state;
  }
};

export default shipmentReducer;
